<template>
  <el-select v-model="value" filterable allow-create default-first-option remote :remote-method="handelRemote"
             size="mini" placeholder="请输入" @change="change">
    <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.name"/>
  </el-select>
</template>

<script>
import {brandLikeQuery} from "@/api/brand";

export default {
  name: "BrandSelect",
  data() {
    return {
      value: null,
      options: []
    }
  },
  methods: {
    async handelRemote(value) {
      const response = await brandLikeQuery({value})
      this.options = response.model || []
    },
    change() {
      const v = this.value
      this.$emit('add', v)
    }
  }
}
</script>

<style scoped>

</style>